export default __webpack_public_path__ + "static/media/27-large.8eae12cc.jpg";